import React, { FC, useState } from 'react';
import MainTemplate from '../components/MainTemplate';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import { shareData } from '../api';
import useSearchParams from '../hooks/useSearchParams';
import { Pages } from '../App';

const AgreementConfirmation: FC<any> = ({ setPage }) => {
  const theme = useTheme();
  const searchParams = useSearchParams();
  const appId = searchParams['app_id'];

  const [isLoading, setIsLoading] = useState(false);

  const submitHandler = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setIsLoading(true);

    const payload = {
      //TODO add when auth will be implemented
      from: '',
      to: appId,
      //TODO add when it will be available
      expires: ''
    };

    try {
      const res: any = await shareData(payload);
      if ('status' in res && res.status === 201) {
        setPage(Pages.Done);
      } else {
        setPage(Pages.Error);
      }
    } catch (e) {
      setPage(Pages.Error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainTemplate>
      <Box>
        <Typography
          variant="subtitle1"
          sx={{
            marginBottom: '10px',
            [theme.breakpoints.down('sm')]: {
              padding: '0 30px'
            }
          }}
        >
          Share your body data?
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{
            marginBottom: '30px',
            [theme.breakpoints.down('sm')]: {
              padding: '0 30px'
            }
          }}
        >
          Fashion Tech invited you to share your body data.
        </Typography>
        <form onSubmit={submitHandler}>
          <LoadingButton
            type="submit"
            sx={{
              marginBottom: 2,
              background: '#fff',
              [theme.breakpoints.down('sm')]: {
                margin: '0 30px'
              }
            }}
            color="inherit"
            variant="outlined"
            loading={isLoading}
          >
            Continue
          </LoadingButton>
        </form>
      </Box>
    </MainTemplate>
  );
};

export default AgreementConfirmation;
